import React from "react";
import {FormControl, Row, Col, Form, Button} from "react-bootstrap";
import InlineForm from "../FromGroup/InlineForm";
import Component from "../../../components/AscComponent";
import CommonTable from "../Table/CommonTable";
import * as GlobalConst from "../../../components/AscConstants";
import CreatableSelect from 'react-select/creatable';
import {faEdit, faXmark} from "@fortawesome/free-solid-svg-icons";
import { isValidExternalNumber } from "../../../components/AscUtils";
import "./UserElements.css";
import ButtonSpeechBubble from "./SetButtonWithSpeechBubble";

/**
 * 操作者の権限レベル定義を取得する（Issue #460）
 *
 * permission_data が null、または Permission キーが無い場合でも落ちないようにする。
 * userInfo 自体が null / undefined でも && の短絡評価で例外にならない。
 * 該当が無いときは最も権限の狭い user を返し、要素を出さない側へ倒す。
 * サーバ側（PR #393）と同じ方針だが、react-scripts 2.1.8 は ?. を解釈できないため
 * Header.js / Record.js と同じ && チェーンで書く。
 *
 * @param {object} userInfo セッションのユーザー情報
 * @returns {object} GlobalConst.LEVEL_OBJECT の要素
 */
const getOperatorLevelObject = (userInfo) => {
    const permissionData = userInfo && userInfo.permission_data;
    const level = permissionData && permissionData.Permission && permissionData.Permission.level;

    return GlobalConst.LEVEL_OBJECT[level] || GlobalConst.LEVEL_OBJECT.user;
};

/**
 * ユーザーIDアイテム
 * state.user_idが必要
 */
export class ViewUserId extends Component {
    render() {
        return(
            <InlineForm
                key="user_id"
                controlId="user_id"
                label={this.props.langText.Body.UserId}
                readOnly
                children={this.props.state.user_id}>
            </InlineForm>
        )
    }
}

/**
 * パスワードビューアイテム
 * state.passwordが必要
 */
export class ViewPassword extends Component {
    render() {
        return(
            <InlineForm
                key="password"
                controlId="password"
                label={this.props.langText.Body.Password}
                readOnly
                children={this.props.state.password}
            />
        )
    }
}

/**
 * 削除項目ビューアイテム
 * state.selectedDataが必要
 */
export class ViewDeleteUserList extends Component {
    render(){
        return(
            <>
            {this.props.state.isLoginedUser&&
            <p className="validation-message">
                {this.props.state.isLoginedUser}{this.props.langText.Message.User_IsLoginedUserError}
            </p>}
            <CommonTable
                className = "none-overflow"
                label = {this.props.langText.Body.PermissionName}
                showPagination = {true}
                defaultPageSize = {10}
                columns = {[{
                    Header :this.props.langText.Body.UserId,
                    accessor: "user_id",
                },
                {
                    Header :this.props.langText.Body.Name,
                    accessor: "name",
                }]}
                data = {this.props.state.selectedData}
            />
            </>
        );
    }
}

/**
 * ユーザー名入力アイテム
 * state.family_name, state.first_nameが必要
 */
export class EditUserName extends Component {
    render() {
        return (
            <InlineForm
                key="user_id"
                controlId="user_id"
                label={this.props.langText.Body.Name}
                readOnly
            >
                <Row>
                    <Col className = "user_name">
                        <InlineForm
                            key = "family_name"
                            controlId = "family_name"
                            label = {this.props.langText.Body.FamilyName}
                            type = "text"
                            value = {this.props.state.family_name}
                            onChange = {e => this.props.onTextChange_Limit(
                                e, "family_name",this.props.charaLimit.User_username)}
                        />
                    </Col>
                    <Col className = "user_name">
                        <InlineForm
                            key = "first_name"
                            controlId = "first_name"
                            label = {this.props.langText.Body.FirstName}
                            type = "text"
                            value = {this.props.state.first_name}
                            onChange = {e => this.props.onTextChange_Limit(
                                e, "first_name",this.props.charaLimit.User_username)}
                        />
                    </Col>
                </Row>
            </InlineForm>
        );
    }
}

/**
 * ユーザー名表示アイテム
 * state.family_name, state.first_nameが必要
 */
export class ViewUserName extends Component {
    render() {
        let str = this.props.state.family_name + " " + this.props.state.first_name;
        return (
            <InlineForm
                key="user_id"
                controlId="user_id"
                label={this.props.langText.Body.Name}
                readOnly>
                {str.length > 1 ? str : "---"}
            </InlineForm>
        );
    }
}

/**
 * パスワード入力アイテム
 * state.passwordが必要
 */
export class EditPassword extends Component {

    validatePassword(param, dflt = false){
        let validation_flag = dflt;
        if(param){
            validation_flag = super.validatePassword(param);
        }
        return validation_flag;
    }
    render() {
        // 【#460】permission_data が null、または Permission キーが無い場合に落ちないようにする。
        // 見つからない場合は最も権限の狭い user として扱い、要素を出さない側へ倒す。
        // Header.js / Record.js と同じ && チェーンで書く（react-scripts 2.1.8 のため ?. は使えない）。
        const operatorLevelValue = getOperatorLevelObject(this.props.userInfo).value;
        if (!this.props.state.hm73_level || (this.props.state.hm73_level
            && operatorLevelValue
            <= GlobalConst.LEVEL_OBJECT[this.props.state.hm73_level].value)) {
            if (this.props.state.password_change) {
                return(
                    <InlineForm
                        key="password"
                        controlId="password"
                        label={this.props.langText.Body.Password}
                        readOnly
                    >
                        <div className={"user_password_change"}>
                            <ButtonSpeechBubble
                                key = {"user_password_cancel-button"}
                                size="sm"
                                className="user_password_cancel-button"
                                DisplayIcon={faXmark}
                                speechBubble={this.props.langText.Body.PasswordChangeCancel}
                                onClick={() => this.props.propSetState({
                                    password_change: false,
                                    password: null
                                })}
                            />
                            <InlineForm
                                key = "password"
                                controlId = "password"
                                type = "password"
                                value = {this.props.state.password}
                                onChange = {e => this.props.onTextChange(e, "password")}
                                placeholder = {this.props.langText.Body.PasswordPlaceholder}
                                isInvalid = {!this.validatePassword(this.props.state.password,true)}
                            />
                        </div>
                    </InlineForm>
                );
            } else {
                return(
                    <div>
                        <InlineForm
                            key = "password"
                            controlId = "password"
                            label = {this.props.langText.Body.Password}
                            readOnly>
                            <ButtonSpeechBubble
                                key = {"user_password_change-button"}
                                size="sm"
                                className="user_password_change-button"
                                DisplayIcon={faEdit}
                                speechBubble={this.props.langText.Body.PasswordChange}
                                onClick={() => this.props.propSetState({password_change: true})}
                            />
                        </InlineForm>
                    </div>
                );
            }
        } else {
            return(
                <InlineForm
                    key = "password"
                    label = {this.props.langText.Body.Password}
                    readOnly
                    value = {""}
                />
            );
        }
    }
}

/**
 * メールアドレス入力アイテム
 * state.mail_addressが必要
 */
export class EditMailAddress extends Component {
    validateMail(param, dflt = false){
        let validation_flag = dflt;
        if(param){
            validation_flag = super.validateMail(param);
        }
        return validation_flag;
    }

    render(){
        return(
            <InlineForm
                key = "mail_address"
                label = {this.props.langText.Body.MailAddress}
                type = "mail"
                value = {this.props.state.mail_address}
                onChange = {e => this.props.onTextChange_Limit(
                    e, "mail_address",this.props.charaLimit.User_mail_address)}
                isInvalid = {!this.validateMail(this.props.state.mail_address,true)}/>
        );
    }
}

/**
 * メールアドレス表示アイテム
 * state.mail_addressが必要
 */
export class ViewMailAddress extends Component {
    render(){
        return(
            <InlineForm
                key = "mail_address"
                controlId = "mail_address"
                label = {this.props.langText.Body.MailAddress}
                readOnly>
                {this.props.state.mail_address || "---"}
            </InlineForm>
        );
    }
}

/**
 * 電話番号入力アイテム
 * state.tel_numberが必要
 */
export class EditTelNum extends Component {
    validateTelNumber(param, dflt = false){
        let validation_flag = dflt;
        if(param){
            validation_flag = super.validateTelNumber(param);
        }
        return validation_flag;
    }
    render(){
        return(
            <InlineForm
                key = "tel_number"
                label = {this.props.langText.Body.Telno}
                type = "tel_number"
                value = {this.props.state.tel_number}
                onChange = {e => this.props.onTextChange_Limit(
                    e, "tel_number", this.props.charaLimit.User_tel_number)}
                isInvalid = {!this.validateTelNumber(this.props.state.tel_number,true)}/>
        );
    }
}

/**
 * 電話番号表示アイテム
 * state.tel_numberが必要
 */
export class ViewTelNum extends Component {
    render(){
        return(
            <InlineForm
                key = "tel_number"
                controlId = "tel_number"
                label = {this.props.langText.Body.Telno}
                readOnly>
                {this.props.state.tel_number || "---"}
            </InlineForm>
        );
    }
}

/**
 * 電話番号入力アイテム
 * state.external_numberが必要
 */
export class EditExternalNum extends Component {
    isValidExternalNumberInput(inputValue) {
        return isValidExternalNumber(inputValue);
    }

    render(){
        const hasInvalid = this.props.state.external_number_invalids && this.props.state.external_number_invalids.length > 0;
        return(
            <InlineForm
                key = "external_number"
                controlId = "external_number"
                label = {this.props.langText.Body.ExternalNumber}
            >
                <div className={hasInvalid ? "is-invalid" : undefined}>
                    <CreatableSelect
                        isMulti
                        onChange = {e => this.props.onMultiSelectChange_External(e)}
                        placeholder = {this.props.langText.Message.Validation_ExternalTelno || this.props.langText.Message.Validation_Telno}
                        isClearable
                        value={this.props.state.external_number}
                        classNamePrefix="ext"
                        isValidNewOption={(inputValue) => this.isValidExternalNumberInput(inputValue)}
                        /* 下矢印(ドロップダウンインジケータ)と区切り線を除去して通常テキストボックス風に */
                        components={{
                            DropdownIndicator: () => null,
                            IndicatorSeparator: () => null
                        }}
                    />
                </div>
            </InlineForm>
        )
    }
}

/**
 * 電話番号表示アイテム
 * state.external_numberが必要
 */
export class ViewExternalNum extends Component {
    render(){
        let str = "";
        if (this.props.state.external_number.length) {
            this.props.state.external_number.forEach(row => {
                str += row.value + ", "
            });
            str = str.slice(0,str.length - 2);
        } else {
            str = "---";
        }
        return(
            <InlineForm
                key = "external_number"
                controlId = "external_number"
                label = {this.props.langText.Body.ExternalNumber}>
                {str}
            </InlineForm>
        )
    }
}

/**
 * 権限選択アイテム
 * state.hm73_id, state.permissionListが必要
 */
export class SelectPermission extends Component {
    render(){
        // 【#460】上と同じ理由の null ガード。
        const operatorLevelValue = getOperatorLevelObject(this.props.userInfo).value;
        if (!this.props.state.hm73_level || (this.props.state.hm73_level
            && operatorLevelValue
            <= GlobalConst.LEVEL_OBJECT[this.props.state.hm73_level].value)) {
            return(
                <InlineForm
                    key = "hm73_id"
                    label = {this.props.langText.Body.Permission}
                    type = "select"
                    options = {this.props.state.permissionList}
                    value = {this.props.state.hm73_id}
                    onChange = {e => this.props.onSelectChange(e, "hm73_id")}
                    placeholder = {this.props.langText.Message.Validation_Select_input}
                    required
                />
            );
        } else {
            return(
                <InlineForm
                    key = "hm73_id"
                    label = {this.props.langText.Body.Permission}
                    readOnly
                    value = {this.props.state.hm73_name}
                    required
                />
            );
        }
    }
}

/**
 * 権限選択アイテム
 * state.hm73_id, state.permissionListが必要
 */
export class ViewPermission extends Component {
    render(){
        return(
            <InlineForm
                key = "hm73_id"
                controlId = "hm73_id"
                label = {this.props.langText.Body.Permission}
                readOnly>
                {this.props.state.hm73_name}
            </InlineForm>
        );
    }
}

/**
 * デバイス選択アイテム
 * state.hm20_id, state.deviceListが必要
 */
export class SelectDevice extends Component {
    render(){
        return(
            <InlineForm
                key = "hm20_id"
                label = {this.props.langText.Body.Device}
                type = "select"
                isMulti
                closeMenuOnSelect={false}
                options = {this.props.state.deviceList}
                value = {this.props.state.hm20_id}
                onChange = {e => this.props.onMultiSelectChange(e, "hm20_id")}
                placeholder = {this.props.langText.Message.Validation_Select_input}
                isInvalid = {this.props.state.hm73_id ? null : "error"}
                />
        );
    }
}

/**
 * オプションアイテム
 */
export class SelectOptions extends Component {
    getOptionsElements() {
        return Object.entries(GlobalConst.OPTIONS).sort()
            .filter(([key]) => {
                // COMPANY_GATED_OPTIONS に載っているキーは、ログイン中ユーザーの
                // company_options[ゲートフラグ] が真の会社でのみ表示する。
                // 載っていないキーは従来どおり全会社で表示。
                const gateFlag = GlobalConst.COMPANY_GATED_OPTIONS
                    && GlobalConst.COMPANY_GATED_OPTIONS[key];
                if (!gateFlag) return true;
                return !!(this.props.userInfo
                    && this.props.userInfo.company_options
                    && this.props.userInfo.company_options[gateFlag]);
            })
            .map(row => {
                return <row className="options-check-row">
                    <Form.Check
                        className="options-check"
                        key = {row[0]}
                        controlId = {row[0]}
                        checked={!!this.props.state.options[row[0]]}
                        onChange={() => {
                            this.props.propSetState({
                                options: {
                                    ...this.props.state.options,
                                    [row[0]]: !this.props.state.options[row[0]]
                                }
                            })
                        }}/>
                    <div className="options-check-description">
                        {row[1]}
                    </div>
                </row>;
            });
    }
    render(){
        return (<InlineForm
            controlId = "options"
            key = "options"
            label = {this.props.langText.Body.Options}>
            {this.getOptionsElements()}
        </InlineForm>);
    }
}

/**
 * デバイス選択アイテム
 * state.hm20_id, state.deviceListが必要
 */
export class ViewDevice extends Component {
    render(){
        let str = "---";
        for (let i = 0; i < this.props.state.hm20_id.length; i++) {
            if (i === 0) {
                str = "";
            } else {
                str +=", "
            }
            let tmp = this.props.state.deviceList.find(item => item.value === this.props.state.hm20_id[i]);
            str += tmp && tmp.label ? tmp.label : "";
        }
        return(
            <InlineForm
                key = "hm20_id"
                controlId = "hm20_id"
                label = {this.props.langText.Body.Device}>
                {str}
            </InlineForm>
        );
    }
}

/**
 * 種別表示アイテム
 * state.typeが必要
 */
export class ViewType extends Component {
    render() {
        return(
            <InlineForm
                key="type"
                controlId="type"
                label={this.props.langText.Body.Type}
                readOnly
            >
                {this.props.langText.Body[this.props.state.type] || "---"}
            </InlineForm>
        )
    }
}

/**
 * 種別選択アイテム
 * state.typeが必要
 */
export class SelectType extends Component {
    render() {
        return(
            <InlineForm
                key = "type"
                label = {this.props.langText.Body.Type}
                type = "select"
                options = {this.getSelectOption('user_type', this.props.langText.SelectOption)}
                value = {this.props.state.type}
                onChange = {e => this.props.onSelectChange(e, "type")}
                required
            />
        )
    }
}

/**
 * デフォルト録音保持期限表示アイテム
 */
export class ViewDefaultVoicesExpire extends Component {
    render() {
        let {
            langText,
            state
        } = this.props;

        let value_as_days = langText.Value.voices_expire_default[state.type];
        let value_as_years;

        if (Math.floor(value_as_days / 365) > 0) {
            value_as_years = Math.floor(value_as_days / 365);
        } else if (Math.floor(value_as_days / 365) === 0) {
            value_as_years = langText.Body.Half;
        }

        return(
            <InlineForm
                key="default_voices_expire"
                controlId="default_voices_expire"
                label={this.props.langText.Body.DefaultVoicesExpire}
                readOnly
            >
                {`${value_as_years}${langText.Body.Year} (${value_as_days}${langText.Body.Day})`}
            </InlineForm>
        )
    }
}

/**
 * オプション録音保持期限表示アイテム
 * state.option_voices_expireが必要
 */
export class ViewOptionVoicesExpire extends Component {
    render() {
        let {
            langText,
            state
        } = this.props;
        if (state.option_voices_expire > 0) {
            let value_as_days = state.option_voices_expire * 365;
            return(
                <InlineForm
                    key="option_voices_expire"
                    controlId="option_voices_expire"
                    label={langText.Body.OptionVoicesExpire}
                    readOnly
                >
                    {`${state.option_voices_expire}${langText.Body.Year} (${value_as_days}${langText.Body.Day})`}
                </InlineForm>
            )
        } else {
            return(<></>)
        }
    }
}

/**
 * 録音保持期限表示・編集アイテム
 * state.option_voices_expireが必要
 */
export class EditVoicesExpire extends Component {
    render() {
        let {
            langText,
            state,
            onSelectChange
        } = this.props;

        return(
            <Row className = "voices_expire">
                <Col className = "default_voices_expire">
                    <ViewDefaultVoicesExpire
                        langText = {langText}
                        state = {state}
                    />
                </Col>
                <Col>
                    <Row>
                        <Col>
                            <InlineForm
                                key="option_voices_expire"
                                controlId="option_voices_expire"
                                label={langText.Body.OptionVoicesExpire}>
                                <Row>
                                    <Col sm={1} md={1} lg={1} className = "align-items-center">
                                        {"+"}
                                    </Col>
                                    <Col Col sm={4} md={4} lg={4}>
                                        <FormControl
                                            value={state.option_voices_expire}
                                            type="number"
                                            min = "0"
                                            onChange={e => onSelectChange(e.target, "option_voices_expire")}
                                        />
                                    </Col>
                                    <Col className = "align-items-center">
                                        {`${langText.Body.Year} (${state.option_voices_expire*365}${langText.Body.Day})`}
                                    </Col>
                                </Row>
                            </InlineForm>
                        </Col>
                    </Row>
                </Col>
            </Row>
        )
    }
}
/**
 * 二要素認証（メールOTP）状態表示・無効化アイテム（Issue #443）
 * state.mfa_enabled が必要
 * 有効化は利用者本人がアカウント画面から行うため、ここでは OFF のみ提供する。
 */
export class EditMfaOff extends Component {
    render() {
        let {
            langText,
            state,
            onMfaOff
        } = this.props;

        return (
            <InlineForm
                key="mfa_status"
                controlId="mfa_status"
                label={langText.Body.MfaStatus}>
                {/* 親ユーザーとサブユーザーで「対象／状態／操作」の列位置を揃える。
                    列を揃えないと、行ごとにボタンの位置がずれて別々の項目に見える。 */}
                <Row className="mfa-status-row">
                    <Col sm={5} md={5} lg={5} className="mfa-status-target">
                        {state.user_id}
                    </Col>
                    <Col sm={3} md={3} lg={3}>
                        {state.mfa_enabled ? langText.Body.MfaStatusOn : langText.Body.MfaStatusOff}
                    </Col>
                    <Col sm={4} md={4} lg={4} className="mfa-status-action">
                        {state.mfa_enabled && (
                            <Button
                                className="table-button"
                                variant="danger"
                                size="sm"
                                onClick={() => onMfaOff()}
                            >
                                {langText.Body.MfaOffButton}
                            </Button>
                        )}
                    </Col>
                </Row>
                {/* Issue #443: サブユーザーの二要素認証。
                    サーバ側 /User/updateMfaOff は hm16_id の有無で対象を分岐するため、
                    ここから渡す target に hm16_id を必ず含める（渡さないと親ユーザーが OFF になる）。 */}
                {Array.isArray(state.mfa_sub_users) && state.mfa_sub_users.length > 0 && (
                    <div className="mfa-sub-user-list">
                        <div className="mfa-sub-user-title">{langText.Body.MfaSettingSubUserTitle}</div>
                        {state.mfa_sub_users.map(subUser => (
                            <Row key={subUser.hm16_id} className="mfa-status-row">
                                <Col sm={5} md={5} lg={5} className="mfa-status-target">
                                    {subUser.sub_user_id}
                                </Col>
                                <Col sm={3} md={3} lg={3}>
                                    {subUser.mfa_enabled
                                        ? langText.Body.MfaStatusOn
                                        : langText.Body.MfaStatusOff}
                                </Col>
                                <Col sm={4} md={4} lg={4} className="mfa-status-action">
                                    {subUser.mfa_enabled && (
                                        <Button
                                            className="table-button"
                                            variant="danger"
                                            size="sm"
                                            onClick={() => onMfaOff({
                                                hm16_id: subUser.hm16_id,
                                                sub_user_id: subUser.sub_user_id
                                            })}
                                        >
                                            {langText.Body.MfaOffButton}
                                        </Button>
                                    )}
                                </Col>
                            </Row>
                        ))}
                    </div>
                )}
                <div className="mfa-status-note">
                    {langText.Body.MfaOffNote}
                </div>
            </InlineForm>
        )
    }
}

/**
 * サブID（サブユーザー）作成上限の編集アイテム（Issue #541）
 *
 * 上限は hm15_users.options.sub_user_limit（整数）に保存する。DDL 変更は不要。
 * 未設定は既定値（5）として扱うため、空欄のまま保存したときは値を送らない。
 *
 * 入力は 1〜100 に制限する。誤入力（0 を余分に付けるなど）で大量の Cognito ユーザーが
 * 作られるのを防ぐためで、同じ hard cap をサーバー側
 * （server/app/controllers/components/SubUserLimit.js）でも必ず効かせている。
 * ここは画面の抑止にすぎない。
 *
 * state.options が必要。
 */
export class EditSubUserLimit extends Component {
    /** 入力値を options.sub_user_limit へ書き戻す。空欄はキーを削除して「未設定」に戻す */
    onChange = event => {
        const raw = event.target.value;
        const options = {...(this.props.state.options || {})};

        if (raw === "") {
            // 【#541】キーを消すのではなく null を送る。/User/update は
            // Object.assign({}, oldOptions, options) でマージするため、キーが無いと
            // 「変更なし」として旧値が生き残り、空欄にしても既定へ戻らない。
            // null はサーバー側で「既定へ戻す」意図として通り、参照側も既定 5 へ倒す。
            options.sub_user_limit = null;
        } else {
            // type="number" でも "1.5" や "1e2" は入りうるため整数のみ通す。
            // 整数でない値はキーを変えずに読み捨てる（保存時にサーバー側が 400 を返す値を作らない）。
            const value = Number(raw);
            if (!Number.isInteger(value)) return;
            options.sub_user_limit = value;
        }
        this.props.propSetState({options});
    }

    render() {
        const {langText, state, userInfo} = this.props;
        // 【#541】上限の変更は company / system レベルのみ（サーバー側も同じ判定で拒否する）。
        // ここで見るのは User 機能のレベル（permission_data.User.level）で、
        // /User/update が認可に使っているものと同じ。
        const operatorUserLevel = userInfo && userInfo.permission_data
            && userInfo.permission_data.User && userInfo.permission_data.User.level;
        if (operatorUserLevel === GlobalConst.LEVEL_OBJECT.user.name) {
            return <></>;
        }
        const value = (state.options && Number.isInteger(state.options.sub_user_limit))
            ? state.options.sub_user_limit
            : "";
        const min = GlobalConst.VALUES.sub_user_limit_min;
        const max = GlobalConst.VALUES.sub_user_limit_max;
        // 範囲外は保存前に気づけるようにする（サーバー側でも 400 で拒否する）
        const isInvalid = value !== "" && (value < min || value > max);

        return (
            <InlineForm
                key="sub_user_limit"
                controlId="sub_user_limit"
                label={langText.Body.SubUserLimit}>
                <Row>
                    <Col sm={4} md={4} lg={4}>
                        <FormControl
                            value={value}
                            type="number"
                            min={min}
                            max={max}
                            step="1"
                            isInvalid={isInvalid}
                            placeholder={GlobalConst.VALUES.sub_user_limit_default}
                            onChange={this.onChange}
                        />
                    </Col>
                    <Col className="align-items-center">
                        {langText.Body.SubUserLimitNote
                            .replace("{default}", GlobalConst.VALUES.sub_user_limit_default)
                            .replace("{max}", max)}
                    </Col>
                </Row>
            </InlineForm>
        )
    }
}
